import { FC } from 'external/react';
import { useNavigate } from 'external/react';
import Icon, { IconName } from 'external/fortawesome';

type PayoutsTableRowProps = {
  payoutData: any;
};

const formatAmount = (amount: number, currency: string) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: currency ?? 'usd' }).format(amount / 100);

const formatDate = (unixTimestamp: number) =>
  new Date(unixTimestamp * 1000).toLocaleDateString();

const statusConfig: Record<string, { icon: IconName; className: string; label: string }> = {
  paid:       { icon: 'faCircleCheck',       className: 'text-success',   label: 'Pagado'      },
  failed:     { icon: 'faCircleExclamation', className: 'text-danger',    label: 'Fallido'     },
  pending:    { icon: 'faSpinner',           className: 'text-warning',   label: 'Pendiente'   },
  in_transit: { icon: 'faSpinner',           className: 'text-info',      label: 'En tránsito' },
  canceled:   { icon: 'faXmark',            className: 'text-secondary', label: 'Cancelado'   },
};


const PayoutsTableRow: FC<PayoutsTableRowProps> = ({ payoutData: item }) => {
  const navigate = useNavigate();
  const p = item.properties;
  const status = statusConfig[p.status] ?? { icon: 'faCircleExclamation', className: 'text-secondary' };

  return (
    <tr style={{ cursor: 'pointer' }} onClick={() => navigate(`/accounting/payouts/${item.id}`)}>
      <td>{formatAmount(p.amount, p.currency)}</td>
      <td>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <Icon name={status.icon} className={status.className} />
          {status.label}
        </span>
      </td>
      <td>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <Icon name="faCalendarDays" className="text-muted" />
          {formatDate(p.arrival_date)}
        </span>
      </td>
      <td>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <Icon name="faCreditCard" className="text-muted" />
          {item.bank_name ? `${item.bank_name} •••• ${item.last4}` : '—'}
        </span>
      </td>
    </tr>
  );
};

export default PayoutsTableRow;